module.exports = __webpack_public_path__ + "img/edit_event_step2_off.2139b66e.png";